import React, { Component } from "react";
import Map from "../Map";
import { BounceLoader } from "react-spinners";
import "./Homepage.css";
import { Link } from "react-router-dom";

import hiro from "../../hiro-updated-white.png";
import { getAllBounties } from "../../utils/bounties";

export default class Homepage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bounties: [],
      areBountiesLoaded: false,
      isMapLoaded: false
    };
  }

  componentDidMount = async () => {
    const { data, status } = await getAllBounties(false);

    if (status === 200) {
      this.setState({
        bounties: data,
        areBountiesLoaded: true
      });
    } else {
      this.setState({
        areBountiesLoaded: true
      });
    }

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(async position => {
        this.setState({
          coordinates: {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          },
          isMapLoaded: true
        });
      });
    } else {
      /* geolocation IS NOT available */
      this.setState({
        coordinates: { lat: 34.07021, lng: -118.44677 },
        isLoaded: true
      });
    }

    // Detects if device is on iOS
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };
    // Detects if device is in standalone mode
    const isInStandaloneMode = () =>
      "standalone" in window.navigator && window.navigator.standalone;

    // Checks if should display install popup notification:
    if (isIos() && !isInStandaloneMode()) {
      this.setState({ showInstallMessage: true });
    }
  };

  render() {
    const {
      areBountiesLoaded,
      bounties,
      coordinates,
      isMapLoaded
    } = this.state;

    return (
      <div className="homepage-container">
        <div className="homepage-bounty-list-container">
          {areBountiesLoaded ? (
            bounties.length > 0 ? (
              <React.Fragment>
                {bounties.map(bounty => {
                  return (
                    <Link
                      to={{
                        pathname: "/bounty",
                        state: bounty
                      }}
                      className="homepage-bounty-list-item shadowed"
                      key={bounty.id}
                      style={{ backgroundImage: `url(${bounty.image})` }}
                      onClick={() => this.props.setPage("/bounty")}
                    >
                      <div className="homepage-bounty-list-item-gradient">
                        <div className="homepage-bounty-list-item-reward">
                          ${bounty.reward}
                        </div>
                        <div className="homepage-bounty-list-item-title">
                          {bounty.title}
                        </div>
                      </div>
                    </Link>
                  );
                })}
                <div className="homepage-hiro-container">
                  <img
                    src={hiro}
                    alt={"Hiro goes here"}
                    style={{
                      width: "9rem"
                    }}
                  />
                  No more bounties!
                </div>
              </React.Fragment>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexFlow: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  color: "white",
                  fontSize: "1.5rem"
                }}
              >
                <img
                  src={hiro}
                  alt={"Hiro goes here"}
                  style={{
                    width: "9rem"
                  }}
                />
                No bounties were found
              </div>
            )
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%"
              }}
            >
              <BounceLoader sizeUnit={"px"} size={50} color={"#ffffff"} />
            </div>
          )}
        </div>
        <div className="homepage-map-container shadowed">
          {isMapLoaded ? (
            <Map
              location={coordinates}
              style={{ height: "59vh !important" }}
              bounties={bounties}
            />
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <BounceLoader sizeUnit={"px"} size={50} color={"#f5841d"} />
            </div>
          )}
        </div>
      </div>
    );
  }
}
